<template>
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.5 32V20C36.5 16.6863 33.8137 14 30.5 14H29H23H21.5C18.1863 14 15.5 16.6863 15.5 20V32C15.5 35.3137 18.1863 38 21.5 38H30.5C33.8137 38 36.5 35.3137 36.5 32Z"
      fill="var(--sf-illustration-primary-background-primary)"
    />
    <path
      d="M18.6667 8.66667H16.3333C13.0196 8.66667 10.3333 11.353 10.3333 14.6667V29.3333C10.3333 32.647 13.0196 35.3333 16.3333 35.3333H27.6667C30.9804 35.3333 33.6667 32.647 33.6667 29.3333V14.6667C33.6667 11.353 30.9804 8.66667 27.6667 8.66667H25.3333M18.6667 8.66667V7M18.6667 8.66667V10.3333M18.6667 8.66667H25.3333M25.3333 8.66667V7M25.3333 8.66667V10.3333M17 17H27M17 22H27M17 27H23.6667"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
